var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m490.603 161.395v313.303h-469.198v-313.303c0-16.091 13.052-29.143 29.154-29.143h410.891c16.101 0 29.153 13.052 29.153 29.143z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.405 428.166h469.198v46.532h-469.198z",
    fill: "#b4d0d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.838 90.931h242.333v397.084h-242.333z",
    fill: "#6ec17d",
    transform: "matrix(0 1 -1 0 545.477 33.468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 446.695h-511.991v17.124c0 23.407 18.975 42.382 42.382 42.382h427.227c23.407 0 42.382-18.975 42.382-42.382z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.77 476.448h-55.531c-15.95 0-28.881-12.93-28.881-28.881v-.872h113.292v.872c0 15.951-12.93 28.881-28.88 28.881z",
    fill: "#b4d0d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.707 506.201h-46.316c-23.415 0-42.391-18.975-42.391-42.381v-17.121h46.316v17.121c0 23.406 18.976 42.381 42.391 42.381z",
    fill: "#b4d0d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.889 161.653v43.524c0 25.991-15.525 49.592-39.538 59.564-47.532 19.759-101.162 19.759-148.694 0-24.013-9.972-39.538-33.573-39.538-59.564v-43.524z",
    fill: "#665e66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.854 277.251c-34.943 5.439-71.05 1.278-104.201-12.506-24.013-9.972-39.538-33.573-39.538-59.564v-43.524h59.698v43.524c0 25.991 15.525 49.592 39.538 59.564 14.391 5.985 29.339 10.157 44.503 12.506z",
    fill: "#454045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.889 161.653v17.451l-93.219 49.386c-12.929 6.84-28.402 6.84-41.33 0l-93.219-49.386v-17.451z",
    fill: "#454045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.07 90.08-149.403-79.146c-12.924-6.847-28.4-6.847-41.325 0l-149.403 79.146c-16.777 8.887-16.777 32.922 0 41.809l149.403 79.147c12.924 6.847 28.4 6.847 41.325 0l149.403-79.147c16.777-8.887 16.777-32.921 0-41.809z",
    fill: "#665e66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.466 295.656c-3.413 0-6.181-2.768-6.181-6.181v-100.375l-64.928-74.04c-2.25-2.567-1.994-6.472.572-8.723 2.565-2.251 6.472-1.994 8.723.572l66.462 75.789c.988 1.128 1.534 2.576 1.534 4.075v102.701c-.001 3.415-2.768 6.182-6.182 6.182z",
    fill: "#eab14d"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m313.682 290.883-12.381 21.444c-7.638 13.229 1.909 29.765 17.185 29.765h7.96c15.275 0 24.822-16.536 17.185-29.765l-12.381-21.444c-3.904-6.762-13.664-6.762-17.568 0z",
    fill: "#f4dd45"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#665e66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m250.615 382.313h-154.675c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h154.674c4.267 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.725 7.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.358 349.818h-103.418c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h103.418c4.267 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.3f0e2cc4a32a2c2baa04df9798623ea9.svg";
export { ForwardRef as ReactComponent };